@if (items().length > 0) {
    <div class="toast-stack" [class.toast-stack--expanded]="isExpanded()"
        [class.toast-stack--left]="position() === 'left'" [class.toast-stack--center]="position() === 'center'"
        [class.toast-stack--right]="position() === 'right'"
        [class.toast-stack--top]="verticalPosition() === 'top'"
        [style.bottom.px]="verticalPosition() === 'bottom' ? offsetPx() : null"
        [style.top.px]="verticalPosition() === 'top' ? offsetPx() : null"
        (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

        @for (item of items(); track item.id) {
            <toast-stack-item [item]="item" [stackIndex]="$index" [isExpanded]="isExpanded()" [totalCount]="$count"
                [maxVisibleLayers]="maxVisibleLayers()" (cleared)="onClear($event)" />
        }

        @if (!isExpanded() && items().length > 1) {
            <div class="toast-stack__counter">
                {{ items().length }}
            </div>
        }

        @if (isExpanded() && items().length > 1) {
            <span class="toast-stack__clear-all" (click)="onClearAll()">{{ 'TOAST_STACK.CLEAR_ALL' | translate }}</span>
        }
    </div>
}